import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { List } from '../volkswagen.types';

@Component({
  selector: 'app-vw-list',
  imports: [CommonModule],
  standalone: true,
  template: `
    @if (data.children && data.children.length > 0) {
      <ul class="my-3 space-y-1 rounded-lg bg-slate-50 px-1 py-2">
        <ng-template #childrenContainer></ng-template>
      </ul>
    }

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class VwListComponent extends XMLElementBaseComponent<List> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
